
/**
 * London Lash Pro - Mega Kit Default Options Pre-selector
 * Only runs on the 3-in-1 course product page
 * Only applies defaults when "Mega Kit" variant is selected (not "Pro Kit")
 */
console.log('[LL-Defaults] Script loaded');

(function() {
  'use strict';
  
  // Only run on this specific product
  if (window.location.pathname.indexOf('3-in-1-accredited-online-lash-extensions-course') === -1) {
    console.log('[LL-Defaults] Not on target product page, exiting');
    return;
  }
  
  console.log('[LL-Defaults] On target product page');

  // Check if Mega Kit variant is currently selected
  function isMegaKitSelected() {
    // Check the variant select dropdown
    var variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (selectedOption && selectedOption.text.toLowerCase().indexOf('mega kit') !== -1) {
        return true;
      }
    }
    
    // Also check URL parameter
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    if (variantId) {
      // Check if the selected option in dropdown matches Mega Kit
      var allOptions = document.querySelectorAll('select[name="id"] option');
      for (var i = 0; i < allOptions.length; i++) {
        if (allOptions[i].value === variantId && allOptions[i].text.toLowerCase().indexOf('mega kit') !== -1) {
          return true;
        }
      }
    }
    
    return false;
  }

  // EXACT match mapping: property name (from select name) => default value to select
  var defaultOptions = {
    'Mannequin head': 'Mannequin head - Medium',
    'Isolating Tweezer': 'Straight Isolating Tweezers - TITANIUM GOLD -N20',
    'Curved tweezers': 'Curved Tweezers - TITANIUM GOLD-N5',
    'Glue': 'Lady Bond glue/adhesive - LADY BOND lash adhesive (5ml)',
    'Glue stone': 'Jade Stone - Black',
    'Mascara Wands': 'Disposable Mascara Wands - Black Color 25pcs',
    'Remover': 'Cream Remover (5g) - London Lash cream gel remover',
    'Tape': '3M Micropore Tape - 1pcs',
    'Premade fans': 'Mayfair 3D 0.07 D-curl (1000fans)',
    'Glue stone stickers': 'Glue Stone Or Glue Crystal Stickers - WHITE ( 1 Sheet )',
    'Fibre Brushes': 'Micro Fibre Brushes 20pcs Black',
    'Palette': 'White Palette - Small (15x6cm)',
    'Primer': 'Premium Lash Primer 15ml',
    'Classic lashes #1': 'Classic Mayfair Lashes 0.15 - C / Mix (8-13)',
    'Matt flat lashes': 'Matt Flat Ultra Soft Lashes 0.15 - CC / Mix (8-13)',
    'Pads': 'Foam Pads',
    'Cleanser': 'Purifying Coconut Pro Cleanser - Coconut',
    'Classic lashes #2': 'Classic Mayfair Lashes 0.15 - CC / 7',
    'Classic lashes #3': 'Classic Mayfair Lashes 0.15 - CC / 8',
    'Classic lashes #4': 'Classic Mayfair Lashes 0.15 - CC / 9',
    'Classic lashes #5': 'Classic Mayfair Lashes 0.15 - CC / 10',
    'Classic lashes #6': 'Classic Mayfair Lashes 0.15 - CC / 11',
    'Classic lashes #7': 'Classic Mayfair Lashes 0.15 - CC / 12',
    'Classic lashes #8': 'Classic Mayfair Lashes 0.15 - CC / 13',
    'Classic lashes #9': 'Classic Mayfair Lashes 0.15 - CC / 14',
    'Classic lashes #10': 'Classic Mayfair Lashes 0.15 - CC / 15',
    'Classic lashes #11': 'Mayfair Lashes 0.15 - CC / 16',
    'Classic lashes #12': 'Mayfair Lashes 0.15 - CC / 17'
  };

  function extractPropertyName(selectName) {
    var match = selectName.match(/properties\[([^\]]+)\]/);
    return match ? match[1] : '';
  }

  function applyDefaults() {
    // Only apply defaults for Mega Kit variant
    if (!isMegaKitSelected()) {
      console.log('[LL-Defaults] Not Mega Kit variant, skipping defaults');
      return 0;
    }
    
    var selects = document.querySelectorAll('select[name^="properties["]');
    console.log('[LL-Defaults] Mega Kit selected - applying defaults to ' + selects.length + ' selects');
    
    if (selects.length === 0) return 0;
    
    var count = 0;
    
    selects.forEach(function(select) {
      var selectName = select.getAttribute('name') || '';
      var propertyName = extractPropertyName(selectName);
      
      if (defaultOptions.hasOwnProperty(propertyName)) {
        var defaultValue = defaultOptions[propertyName];
        var options = select.options;
        
        for (var i = 0; i < options.length; i++) {
          var opt = options[i];
          var optVal = (opt.value || '').trim();
          var optText = (opt.textContent || '').trim().replace(' - Sold out', '');
          
          if (optVal === defaultValue || 
              optText === defaultValue ||
              optVal.indexOf(defaultValue) !== -1 || 
              defaultValue.indexOf(optVal) !== -1) {
            
            if (!opt.disabled && optVal !== '') {
              select.value = optVal;
              select.dispatchEvent(new Event('change', { bubbles: true }));
              count++;
              break;
            }
          }
        }
      }
    });
    
    console.log('[LL-Defaults] Applied ' + count + ' defaults');
    return count;
  }

  // The key insight: the IO rendering script in product-form.liquid uses
  // setTimeout at 50ms, 150ms, 250ms, and 900ms after boot.
  // We need to run AFTER all those complete.
  
  function init() {
    console.log('[LL-Defaults] Initializing - waiting for IO render to complete...');
    
    // Wait for IO rendering to finish (runs at 50, 150, 250, 900ms)
    // We'll run at 1000ms, 1500ms, and 2000ms to be safe
    setTimeout(function() { applyDefaults(); }, 1000);
    setTimeout(function() { applyDefaults(); }, 1500);
    setTimeout(function() { applyDefaults(); }, 2000);
    
    // Also watch for future re-renders (variant changes)
    var lastSelectCount = 0;
    var observer = new MutationObserver(function(mutations) {
      // Check if new selects appeared (IO re-rendered)
      var currentCount = document.querySelectorAll('select[name^="properties["]').length;
      if (currentCount > 0 && currentCount !== lastSelectCount) {
        lastSelectCount = currentCount;
        // Wait for rendering to settle
        setTimeout(function() { applyDefaults(); }, 200);
        setTimeout(function() { applyDefaults(); }, 500);
      }
    });
    
    var mount = document.querySelector('[data-sb-io-options]');
    if (mount) {
      observer.observe(mount, { childList: true, subtree: true });
    }
    
    // Stop observer after 60s
    setTimeout(function() {
      observer.disconnect();
      console.log('[LL-Defaults] Observer stopped');
    }, 60000);
  }

  // Start after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
